export default "__VITE_ASSET__0ca4f302__"